import {StatusLogActions, StatusLogActionTypes} from '../actions/status-log.actions';
import {StatusLog} from '../status.model';


export interface StatusLogState {
  Loaded: boolean;
  Loading: boolean;
  entities: StatusLog[];
}

export const initialState: StatusLogState = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(state = initialState, action: StatusLogActions): StatusLogState {
  switch (action.type) {
    case StatusLogActionTypes.GetStatusLogs:
      return {...state, Loaded: false, Loading: true};
    case StatusLogActionTypes.LoadStatusLogs:
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    case StatusLogActionTypes.GetStatusLogsFail:
      return {...state, Loaded: true, Loading: false, entities: []};
    case StatusLogActionTypes.ClearStatusLogs:
      return {...state, Loaded: true, Loading: false, entities: []};

    default:
      return state;
  }
}
